/* projects/shared/nvps-libraries/design/nv-box-button/nv-box-button.component.scss */
nv-box-button button {
  display: flex;
  box-sizing: border-box;
  background: var(--color-white);
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  height: var(--space-xxl);
  border: 1px solid var(--color-grey-light-8);
  border-radius: 8px;
}
nv-box-button button span {
  padding: 0px 0px 0px var(--space-m);
  font-size: 16px;
  letter-spacing: 0.0192em;
  line-height: 145%;
  font-family: var(--font-family-normal);
  font-style: normal;
  font-weight: 400;
  font-family: "NvLatoSemibold";
  font-weight: 600;
  text-transform: none;
  color: var(--color-blue);
  max-width: 222px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
nv-box-button button nv-icon {
  padding: 0px var(--space-s);
}
nv-box-button button.box-disabled {
  opacity: 0.7;
  pointer-events: none;
}
nv-box-button button.box-disabled span {
  opacity: 0.7;
  color: var(--color-primary-text-disabled);
}
nv-box-button {
  display: inline-block;
}
nv-box-button button {
  cursor: pointer;
}
nv-box-button button[style*=max-width] span {
  max-width: none;
}
nv-box-button button span.both-sides {
  padding: 0px;
}
nv-box-button button.small {
  height: var(--space-xl);
}
nv-box-button button.small span {
  font-size: var(--font-xs);
}
nv-box-button button.no-border {
  border: none;
}
nv-box-button button.icon-bothSides > nv-icon:first-of-type {
  width: var(--space-m);
  height: var(--space-m);
}
/*# sourceMappingURL=nv-box-button.component-CEX5F5TI.css.map */
